import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_TEACHERS: 'fetchTeachers'
}

export const globalActions = getNamespacedBy('teacher', actionTypes)
